import { render } from "./BaseSpinner.vue?vue&type=template&id=1700ba0d&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=1700ba0d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1700ba0d"

export default script